import { mockInsightEntityActivityQueryQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

import { insightEntityActivityMockResponse } from 'app/InsightDetail/InvolvedEntities/InsightEntityRelationships/mocks';

export const handlers = [
  mockInsightEntityActivityQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insightEntityActivity: insightEntityActivityMockResponse,
        },
      });
    }
  ),
];
